import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createSlots as _createSlots, withModifiers as _withModifiers, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c01de592"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "チェックシートの回答結果", -1))
const _hoisted_2 = {
  key: 0,
  class: "relative-position",
  style: {"min-height":"200px"}
}
const _hoisted_3 = { class: "absolute-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  class: "page-section-title",
  style: {"margin-bottom":"20px"}
}
const _hoisted_6 = { class: "row justify-between" }
const _hoisted_7 = {
  class: "col-12 col-sm-6 flex",
  style: {"gap":"7px"}
}
const _hoisted_8 = { class: "search-select" }
const _hoisted_9 = { class: "search-input" }
const _hoisted_10 = { class: "search-btn" }
const _hoisted_11 = {
  key: 0,
  class: "col-12 col-sm-6"
}
const _hoisted_12 = { class: "download-btnList" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Excelでダウンロード ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" CSVでダウンロード ")
const _hoisted_15 = {
  key: 0,
  class: "q-mt-lg q-mb-sm"
}
const _hoisted_16 = { class: "col-xs-12 col-sm-6 col-md-4 q-mb-md" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, "（確認済）", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { class: "full-width flex justify-center" }
const _hoisted_25 = { class: "full-width text-center" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "page-section-title" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "このページはパスワードでロックされています。", -1))
const _hoisted_29 = { class: "row q-gutter-sm" }
const _hoisted_30 = { class: "col-grow" }
const _hoisted_31 = { class: "col-shrink" }
const _hoisted_32 = { class: "q-mt-md" }

import { ref, computed, watch, reactive } from 'vue'
import { useRoute } from 'vue-router'
import { useAsyncTask } from 'vue-concurrency'
import { QTableProps, Dialog, LooseDictionary, QTable } from 'quasar'
import api from '@/api'
import { BookNavi, ResultDetailDialog } from '@/components'
import { useRemind, useLock } from '@/composables'
import { Book, Pagination } from '@/models'
import { useErrorStore, useBookStore } from '@/stores'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const errorStore = useErrorStore()
const bookStore = useBookStore()

const bookHash = computed(() => route.query.cd as string)

/* Bookデータ */

const book = ref(new Book())

const bookTask = useAsyncTask(async () => {
  return api.book
    .get({ cd: bookHash.value })
    .then(data => {
      book.value = data
      // パスワードの検証
      isUnlocked.value = data.bookPass === null || bookStore.isUnlocked(data.bookHash)
      // console.log(book.value);
      return data
    })
    .catch(errorStore?.go)
}).drop()

bookTask.perform()

// パスワード保護
const { isUnlocked, lockForm, unlock } = useLock(book)
const table = ref<QTable>()
const columns = ref<QTableProps['columns']>([])
const rows = ref<QTableProps['rows']>([])

/** 検索フォーム入力データ */
const inputs = reactive({
  searchWord: '',
  confirmFlg: 0,
})

/** ページネーションデータ */
const pagination = reactive<Pagination>({
  descending: true,
  page: 1,
  sortBy: 'insDt',
  rowsPerPage: 10,
  rowsNumber: 0,
})
/** 検索ボタン押下時 */
function onSearch() {
  // 空文字を削除
  const query = Object.fromEntries(Object.entries(inputs).filter(([, v]) => v !== ''))
  // API送信。ページは1ページ目にする
  void resultTask.perform({ filter: query, page: { ...pagination, pageNum: 1 } })
}

function onUpdatePaginationPage(value: string) {
  if (!table.value) return
  table.value.setPagination({
    ...(pagination ? pagination : {}),
    page: Number(value),
  })
}

function onUpdatePagination(value: any) {
  Object.assign(pagination, value.pagination)
  void resultTask.perform({ filter: inputs, page: pagination })
}

const resultTask = useAsyncTask(async (signal, query) => {
  return api.sheet
    .list(bookHash.value, {
      filter: query.filter,
      pagination: query.page,
    })
    .then(data => {
      columns.value = data.resultList.columns.map(row => ({
        ...row,
        align: row.name === 'note' ? 'left' : 'center',
        sortable: true,
        style: 'max-width: 160px; text-overflow: ellipsis ; white-space: nowrap; overflow: hidden;',
      }))

      rows.value = data.resultList.rows
      Object.assign(pagination, data.pagination)
      return data
    })
    .catch(errorStore?.go)
}).drop()

// ロック解除状態なら結果一覧を取得
watch(
  isUnlocked,
  () => {
    isUnlocked.value && resultTask.perform({ filter: inputs, page: pagination })
  },
  { immediate: true },
)

/* 有料会員 */
const isPaidUser = true

/** パスワードリマインド */
const { task: remindTask, remind } = useRemind(bookHash.value)

/** テーブルの行をクリックで回答詳細モーダル表示 */
const showDetailModal = (e: LooseDictionary, row: { [key: string]: string | number }) => {
  Dialog.create({
    component: ResultDetailDialog,
    componentProps: { answerHash: row.answerHash },
  })
}

return (_ctx: any,_cache: any) => {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_pagination = _resolveComponent("q-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_unref(bookTask).isRunning)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_q_spinner, {
                  showing: "",
                  color: "grey",
                  size: "100px",
                  thickness: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(isUnlocked))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_unref(BookNavi), {
                      class: "q-my-md",
                      "book-hash": book.value.bookHash,
                      "sheet-hash": book.value.sheetHash
                    }, null, 8, ["book-hash", "sheet-hash"]),
                    _createElementVNode("section", null, [
                      _createElementVNode("h2", _hoisted_5, _toDisplayString(book.value.bookName), 1),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_q_select, {
                              modelValue: _unref(inputs).confirmFlg,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(inputs).confirmFlg) = $event)),
                              options: [
                      {
                        label: 'すべて',
                        value: 0,
                      },
                      {
                        label: '未確認',
                        value: 1,
                      },
                      {
                        label: '確認済',
                        value: 2,
                      },
                    ],
                              label: "確認有無",
                              "emit-value": "",
                              "map-options": "",
                              outlined: "",
                              dense: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_q_input, {
                              class: "input",
                              type: "text",
                              outlined: "",
                              dense: "",
                              modelValue: _unref(inputs).searchWord,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(inputs).searchWord) = $event)),
                              placeholder: "キーワード"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_q_btn, {
                              class: "button",
                              onClick: onSearch,
                              unelevated: "",
                              color: "primary",
                              label: "検索"
                            })
                          ])
                        ]),
                        (isPaidUser && !_ctx.$q.screen.lt.sm)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_q_btn, {
                                  outline: "",
                                  type: "a",
                                  download: "",
                                  href: book.value.url.bookexcel
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                      name: "fas fa-file-excel",
                                      size: "xs",
                                      style: {"margin-right":"3px"}
                                    }),
                                    _hoisted_13
                                  ]),
                                  _: 1
                                }, 8, ["href"]),
                                _createVNode(_component_q_btn, {
                                  outline: "",
                                  type: "a",
                                  download: "",
                                  href: book.value.url.bookcsv
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                      name: "fas fa-file-csv",
                                      size: "xs",
                                      style: {"margin-right":"3px"}
                                    }),
                                    _hoisted_14
                                  ]),
                                  _: 1
                                }, 8, ["href"])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (book.value.answerCnt > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, "回答の行をクリックすると詳細情報が表示されます。"))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(QTable), {
                        ref: (_value, _refs) => {
                          _refs['table'] = _value
                          table.value = _value
                        },
                        flat: "",
                        bordered: "",
                        square: "",
                        dense: "",
                        onRowClick: showDetailModal,
                        onRequest: onUpdatePagination,
                        "onUpdate:pagination": onUpdatePagination,
                        rows: rows.value,
                        columns: columns.value,
                        pagination: _unref(pagination),
                        loading: _unref(resultTask).isRunning,
                        "no-data-label": "回答結果がありません",
                        grid: _ctx.$q.screen.lt.sm,
                        "hide-pagination": !_unref(pagination)
                      }, _createSlots({
                        header: _withCtx((props) => [
                          _createVNode(_component_q_tr, { props: props }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                                return (_openBlock(), _createBlock(_component_q_th, {
                                  key: col.name,
                                  props: props,
                                  class: "bg-grey-1",
                                  style: {"font-weight":"bold"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(col.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["props"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["props"])
                        ]),
                        item: _withCtx((props) => [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", {
                              class: "sp-table-content",
                              onClick: ($event: any) => (showDetailModal($event, props.row))
                            }, [
                              (props.row.c1)
                                ? (_openBlock(), _createElementBlock("dl", _hoisted_18, _hoisted_20))
                                : _createCommentVNode("", true),
                              (props.row.k1)
                                ? (_openBlock(), _createElementBlock("dl", _hoisted_21, [
                                    _createElementVNode("dd", null, _toDisplayString(props.row.k1), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (props.row.k2)
                                ? (_openBlock(), _createElementBlock("dl", _hoisted_22, [
                                    _createElementVNode("dd", null, _toDisplayString(props.row.k2), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (props.row.k3)
                                ? (_openBlock(), _createElementBlock("dl", _hoisted_23, [
                                    _createElementVNode("dd", null, _toDisplayString(props.row.k3), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_17)
                          ])
                        ]),
                        "no-data": _withCtx(({ message }) => [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(message), 1)
                        ]),
                        _: 2
                      }, [
                        (_unref(pagination))
                          ? {
                              name: "bottom",
                              fn: _withCtx(({ pagesNumber, isFirstPage, isLastPage, firstPage, prevPage, nextPage, lastPage }) => [
                                _createElementVNode("div", _hoisted_24, [
                                  (pagesNumber > 2)
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 0,
                                        icon: "first_page",
                                        color: "primary",
                                        round: "",
                                        dense: "",
                                        flat: "",
                                        disable: isFirstPage,
                                        onClick: firstPage
                                      }, null, 8, ["disable", "onClick"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_q_btn, {
                                    icon: "chevron_left",
                                    color: "primary",
                                    round: "",
                                    dense: "",
                                    flat: "",
                                    disable: isFirstPage,
                                    onClick: prevPage
                                  }, null, 8, ["disable", "onClick"]),
                                  _createVNode(_component_q_pagination, {
                                    "model-value": _unref(pagination).page,
                                    color: "primary",
                                    unelevated: "",
                                    max: pagesNumber,
                                    "onUpdate:modelValue": onUpdatePaginationPage
                                  }, null, 8, ["model-value", "max"]),
                                  _createVNode(_component_q_btn, {
                                    icon: "chevron_right",
                                    color: "primary",
                                    round: "",
                                    dense: "",
                                    flat: "",
                                    disable: isLastPage,
                                    onClick: nextPage
                                  }, null, 8, ["disable", "onClick"]),
                                  (pagesNumber > 2)
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 1,
                                        icon: "last_page",
                                        color: "primary",
                                        round: "",
                                        dense: "",
                                        flat: "",
                                        disable: isLastPage,
                                        onClick: lastPage
                                      }, null, 8, ["disable", "onClick"]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            }
                          : undefined
                      ]), 1032, ["rows", "columns", "pagination", "loading", "grid", "hide-pagination"])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("h2", _hoisted_27, _toDisplayString(book.value.bookName), 1),
                    _hoisted_28,
                    _createElementVNode("form", {
                      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_unref(unlock) && _unref(unlock)(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_q_input, {
                            type: "password",
                            dense: "",
                            outlined: "",
                            "stack-label": "",
                            label: "パスワード",
                            modelValue: _unref(lockForm).password,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(lockForm).password) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_q_btn, {
                            unelevated: "",
                            type: "submit",
                            color: "primary",
                            label: "ロックを解除する"
                          })
                        ])
                      ])
                    ], 32),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_q_btn, {
                        outline: "",
                        color: "dark",
                        label: "パスワードをお忘れの場合はこちら",
                        onClick: _unref(remind),
                        loading: _unref(remindTask).isRunning
                      }, null, 8, ["onClick", "loading"])
                    ])
                  ]))
            ], 64))
      ]),
      _: 1
    })
  ]))
}
}

})